require('../scss/narxcare_tutorials.scss') // eslint-disable-line no-undef

// JQuery
import ncjQuery from 'jquery'
window.ncjQuery = ncjQuery;

window.NarxcareSlideShow = function (jQuery, page_count_selector) {
  "use strict";
  var obj = {};
  var slideIndex = 1;
  var slides = [];

  var $ = jQuery;

  obj.page_count_el = $(page_count_selector);

  // Next/previous controls
  obj.nextSlide = function() {
    obj.showSlide(slideIndex + 1);
  }
  obj.previousSlide = function() {
    obj.showSlide(slideIndex - 1);
  }

  obj.firstSlide = function() {
    obj.showSlide(slides.length);
  }
  obj.lastSlide = function() {
    obj.showSlide(1);
  }
  obj.getCurrentSlide = function() {
    return slideIndex;
  }

  function hideAllSlides(slides) {
    var i;
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
  }

  obj.showSlide = function(n) {

    if (n == 0) {
      return false;
    }
    if (n == (slides.length + 1) ) {
      return false;
    }

    //var dots = document.getElementsByClassName("dot");
    if (n > slides.length) { slideIndex = 1 }
    else if (n < 1) { slideIndex = slides.length }
    else { slideIndex = n; }

    hideAllSlides(slides);

    slides[slideIndex - 1].style.display = "block";

    obj.page_count_el.text('Page ' + slideIndex + ' of ' + slides.length);

    return false;
  }

  function setup() {
    slides = document.getElementsByClassName("slide");
    obj.showSlide(slideIndex);
  }
  setup();

  return obj;
};

